import React from 'react'

import type {
  PeriodikPerformancePracticeResult,
  PeriodikWorkBehaviorResult,
} from 'types/kinerja'
import type { PenetapanPegawaiFilterEnum } from 'types/kinerja-tim-penilai-ps'
import type {
  PenetapanPegawaiState,
  PenetapanPredikatKinerjaRating,
} from 'types/kinerja-ps-pegawai'

// Rating Predikat Kinerja
export const PENETAPAN_PEGAWAI_PREDIKAT_RATING_OPTIONS: Record<
  PenetapanPredikatKinerjaRating,
  string
> = {
  VERY_GOOD: 'Sangat Baik',
  GOOD: 'Baik',
  NEED_IMPROVEMENT: 'Butuh Perbaikan',
  BAD: 'Kurang',
  VERY_BAD: 'Sangat Kurang',
  NOT_SET: 'Belum Ditetapkan',
}
export const PENETAPAN_PEGAWAI_PREDIKAT_RATING_BADGE_COLORS: Record<
  PenetapanPredikatKinerjaRating,
  string
> = {
  VERY_GOOD: '#BBE2B8',
  GOOD: '#E2F5E0',
  NEED_IMPROVEMENT: '#FFEFD6',
  BAD: '#FEEDF2',
  VERY_BAD: '#FECACE',
  NOT_SET: '#C7C7C7',
}
export const PENETAPAN_PEGAWAI_PREDIKAT_RATING_CHART_POINT_COLORS: Record<
  PenetapanPredikatKinerjaRating,
  string
> = {
  VERY_GOOD: '#5FB05E',
  GOOD: '#9FD49D',
  NEED_IMPROVEMENT: '#F7D63A',
  BAD: '#FECACE',
  VERY_BAD: '#FF8C8C',
  NOT_SET: '#C7C7C7',
}

// Sent State
export const PENETAPAN_PEGAWAI_STATE_LABELS: Record<
  PenetapanPegawaiState,
  string
> = {
  NOT_RATED: 'Belum Dikirim',
  NOT_SENT: 'Belum Dikirim',
  SENT_TO_PPK: 'Sudah Dikirim',
  SENDING_TO_BKN: 'Sudah Dikirim',
  SENT_TO_BKN: 'Sudah Dikirim',
  ERROR_SEND: 'Sudah Dikirim',
}

export const PENETAPAN_PEGAWAI_PRAKTIK_KINERJA_RECOMMENDATION: Record<
  PeriodikPerformancePracticeResult,
  React.ReactNode
> = {
  BELOW_EXPECTATION: (
    <>
      Berdasarkan hasil pemantauan Anda, terlihat upaya dalam melaksanakan
      praktik. Namun, penerapannya tampak <strong>belum selaras</strong> dengan
      rencana dan
      <strong>perlu ditingkatkan</strong> melalui{' '}
      <strong>pendampingan berkala</strong>. Refleksi juga terlihat masih
      bersifat umum.
      <br />
      <br />
      Temuan ini sejalan dengan Rating:
    </>
  ),
  MEET_EXPECTATION: (
    <>
      Berdasarkan hasil pemantauan Anda, tampak upaya yang secara terus-menerus
      dilakukan <strong>selaras dengan kesepakatan bersama</strong>. Refleksi
      juga terlihat bersumber dari analisis terhadap diri sendiri.
      <br />
      <br />
      Perkembangan ini dapat diartikan sebagai Rating:
    </>
  ),
  EXCEED_EXPECTATION: (
    <>
      Selama periode ini, Pegawai terlihat menerapkan praktik yang{' '}
      <strong>melampaui target</strong> yang direncanakan. Praktik baik tampak{' '}
      <strong>diikuti oleh rekan sejawat</strong>. Refleksi juga terlihat
      mendalam dan <strong>berpengaruh positif</strong>.
      <br />
      <br />
      Keseluruhan capaian ini dapat selaras dengan Rating:
    </>
  ),
}

export const PENETAPAN_PEGAWAI_PERILAKU_KERJA_RECOMMENDATION: Record<
  PeriodikWorkBehaviorResult,
  React.ReactNode
> = {
  BELOW_EXPECTATION: (
    <>
      Berdasarkan hasil pemantauan Anda, terlihat kemauan dan usaha belajar.
      Meski demikian, penerapannya tampak <strong>belum sesuai</strong> dengan
      rencana dan
      <strong>membutuhkan pengembangan</strong> melalui{' '}
      <strong>arahan berkala</strong>.
      <br />
      <br />
      Temuan ini dapat sejalan dengan Rating:
    </>
  ),
  MEET_EXPECTATION: (
    <>
      Berdasarkan hasil pemantauan Anda, tampak perubahan sikap yang{' '}
      <strong>sesuai dengan kesepakatan bersama</strong>. Perubahan juga
      terlihat memiliki pengaruh, meski hanya terbatas.
      <br />
      <br />
      Perkembangan ini dapat diartikan sebagai Rating:
    </>
  ),
  EXCEED_EXPECTATION: (
    <>
      Selama periode ini, Pegawai terlihat dapat melakukan pelaksanaan dengan
      konkret dan turut <strong>mendampingi rekan sejawat</strong>. Pelaksanaan
      tampak <strong>menjadi contoh</strong> dan{' '}
      <strong>dapat diandalkan</strong> bagi satuan pendidikan.
      <br />
      <br />
      Keseluruhan capaian ini dapat selaras dengan Rating:
    </>
  ),
}

export const PENETAPAN_PEGAWAI_RATING_RECOMMENDATION_BADGE_VARIANTS: Record<
  PeriodikPerformancePracticeResult,
  string
> = {
  BELOW_EXPECTATION: 'critical',
  MEET_EXPECTATION: 'informational',
  EXCEED_EXPECTATION: 'success',
}

export const PENETAPAN_PEGAWAI_FILTER_LABELS: Record<
  PenetapanPegawaiFilterEnum,
  string
> = {
  PPK_SENT: 'Sudah dikirim',
  PPK_NOT_SENT: 'Belum dikirim',
  PPK_NOT_RATED: 'Belum selesai dinilai',
  TK_SENT: 'Sudah dikirim',
  TK_NOT_SENT: 'Belum dikirim',
}

export const PENETAPAN_PEGAWAI_RATING_BADGE_COLORS = {
  BELOW_EXPECTATION: '!bg-red-20',
  MEET_EXPECTATION: '!bg-blue-20',
  EXCEED_EXPECTATION: '!bg-green-20',
}
